module.exports = __webpack_public_path__ + "img/Overzichten.d256c623.png";